// The link the hero has attached, and the chip it renders once a preview resolves.

import type { PreviewSuccess } from './errorCodes';
import type { SocialPostPlatformId } from './platforms';
import type { SocialPostClassification } from './utils';

export type AttachedPost = { platform: SocialPostPlatformId; url: string; handle: string | undefined };

export type Chip = { handle: string | undefined; title: string | undefined; image: string | undefined };

export function toAttachedPost(link: Extract<SocialPostClassification, { kind: 'supported_link' }>): AttachedPost {
	return { platform: link.platform, url: link.url, handle: link.handle };
}

export function toChip(post: AttachedPost | undefined, preview: PreviewSuccess | undefined): Chip | undefined {
	if (!post || !preview) return undefined;
	return { handle: post.handle, title: preview.title ?? undefined, image: preview.image ?? undefined };
}
